<app-protected-information *ngIf="this.configurationService.application.enablePrivacyAct && !this.isAmericanCitizen(this.application)"></app-protected-information>
<div class="row mt-3">
  <div class="col">
    <h5 *ngIf="!readDoc10" class="text-center">{{ "onboarding.contracts-consents.consentsInstructions" | translate: {Default:"Lea/acepte cada uno de los siguientes consentimientos."} }}</h5>
    <div class="container">
          <form #form="ngForm" (ngSubmit)="form.form.valid && openModal(modalDecision)" novalidate>
            <div class="row justify-content-md-center mb-4">
              <div class="col-12 ">
                <div class="card-body">
                  <div class="row justify-content-center">
                    <div class="col-12 col-md-9">
                      <p *ngIf="!readDoc10"><b>{{ "onboarding.contracts-consents.agreementsConsent" | translate: {Default:" He leído y estoy de acuerdo con las divulgaciones de los siguientes documentos"} }}</b></p>
                      <p *ngIf="readDoc10"><b>{{ "onboarding.contracts-consents.agreementsConsentCheck" | translate: {Default:" Estoy de acuerdo con las divulgaciones de los documentos"} }}</b></p>
                      <ul *ngIf="!readDoc10">
                        <li class="m-0 mb-1">{{ "onboarding.contracts-consents.shortFormAgreement" | translate: {Default:" Pre-adquisición (Forma breve y forma larga)"} }}</li>
                        <li class="m-0 mb-1">{{ "onboarding.contracts-consents.idConsentAgreement" | translate: {Default:" Comunicación Electrónica de Divulgación (E-sign)"} }}</li>
                        <li class="m-0 mb-1">{{ "onboarding.contracts-consents.cardHolderAgreement" | translate: {Default:" Contrato con el Tarjetahabiente (incluye Términos y condiciones interbancarias)"} }}</li>
                        <li class="m-0 mb-1">{{ "onboarding.contracts-consents.privacyPolicyAdvice" | translate: {Default:" Política de Privacidad"} }}</li>
                      </ul>
                    </div>
                    <div class="col-12 col-md-3 text-center text-md-right mb-3 mb-md-0 mt-1">
                      <div class="btn-group btn-group-sm" role="group">
                        <i *ngIf="readDoc10" class="fas fa-check text-success"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <button class="btn btn-secondary float-left" type="button" (click)="onBack()">{{ "onboarding.contracts-consents.back" | translate: {Default:"Regresar"} }}</button>
              <a *ngIf="!readDoc10"  class="text-black-50 float-right" [href]="urlDoc10" target="_blank" (click)="onDocumentRead()">
                <button class="btn btn-primary mb-sm-2">{{ "onboarding.contracts-consents.read" | translate: {Default:"Leer"} }}</button>
              </a>
              <button *ngIf="readDoc10" class="btn btn-primary float-right" type="submit" [disabled]="!application.body.shortFormAgreement || !application.body.idConsent || !application.body.privacyAdvice || !application.body.cardHolderAgreement">{{ "onboarding.contracts-consents.continue" | translate: {Default:"Continuar"} }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>

<ng-template #modalDecision let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ "onboarding.contracts-consents.confirmAgreements" | translate: {Default:"Confirmar términos"} }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>{{ "onboarding.contracts-consents.accept-rates" | translate: {Default:"Estoy de acuerdo con las divulgaciones de los documentos."} }}</p>
  </div>
  <div class="modal-footer justify-content-between">
    <button type="button" class="btn btn-outline-secondary" (click)="c('close');onCancel()">{{ "onboarding.contracts-consents.back" | translate: {Default:"Regresar"} }}</button>
    <button type="button" class="btn btn-success" (click)="onSubmit()" >{{ "onboarding.contracts-consents.accept" | translate: {Default:"Acepto"} }}</button>
  </div>
</ng-template>

